module.exports = __webpack_public_path__ + "static/media/animated_junaid.b8767b1e.png";